import { lazy } from 'react';
import type { RouteObject } from 'react-router-dom';

import { PageElement } from './Page';

const ParamsConfig = lazy(() =>
    import('@/v1/setting/views/ParamsConfig').then((module) => ({
        default: module.ParamsConfig,
    }))
);

export const paramsConfigRoutes: RouteObject[] = [
    {
        path: `params_config`,
        ...PageElement(<ParamsConfig />),
    },
];
